import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const STATS = [
  { value: 99.99, suffix: "%", label: "Uptime delivered", decimals: 2 },
  { value: 15, suffix: "min", label: "Avg. response time", decimals: 0, prefix: "<" },
  { value: 250, suffix: "+", label: "Endpoints managed", decimals: 0 },
  { value: 12, suffix: "yrs", label: "Keeping clients online", decimals: 0 },
];

const Counter = ({ value, decimals, prefix = "", suffix = "", start }) => {
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    if (!start) return;
    let raf;
    const duration = 1600;
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min((now - t0) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(value * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [start, value]);

  return (
    <span>
      {prefix}
      {display.toFixed(decimals)}
      <span className="text-[#00E5FF]">{suffix}</span>
    </span>
  );
};

export const Stats = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-15%" });

  return (
    <section
      id="results"
      ref={ref}
      data-testid="stats-section"
      className="relative bg-[#0A0A0C] border-y border-white/10 py-20 md:py-28"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-14 gap-x-8">
          {STATS.map((s, i) => (
            <div key={i} data-testid={`stat-${i}`} className="flex flex-col">
              <div className="text-4xl md:text-6xl font-black tracking-tighter text-white">
                <Counter {...s} start={inView} />
              </div>
              <div className="mt-3 h-px w-12 bg-[#00E5FF]/50" />
              <p className="mt-4 text-sm md:text-base text-[#A0AEC0] uppercase tracking-wide">
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
